export default "__VITE_ASSET__Bby8Njq0__"